








import PageLayout from "@/common/layout/PageLayout.vue";
import Component from "vue-class-component";
import { Page } from "@/layout/mixin/Page";

@Component({
  components: { PageLayout }
})
export default class CustomerPage extends Page {
  title: string = "Klient";
}
